<template>
  <m-layout-grid class="app-inmuebles-list-filter-full">
    <m-layout-grid-inner>
      <m-layout-grid-cell :span-phone="2" :span-tablet="4" :span-desktop="3">
        <m-select
          v-if="tipoBienSelect.rendered"
          v-model="tipoBienSelect.valueSelected"
          id="tipobien-select"
          outlined
        >
          <option
            v-for="option in tipoBienSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="tipoBienSelect.valueSelected === option.value"
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="tipobien-select"
            :floatAbove="!!tipoBienSelect.valueSelected"
          >
            {{ tipoBienSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="4" :span-desktop="3">
        <m-select
          v-if="provinciaSelect.rendered"
          v-model="provinciaSelect.valueSelected"
          id="provincia-select"
          outlined
        >
          <option
            v-for="option in provinciaSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="provinciaSelect.valueSelected === option.value"
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="provincia-select"
            :floatAbove="!!provinciaSelect.valueSelected"
          >
            {{ provinciaSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="4" :span-desktop="3">
        <m-text-field
          v-model="municipio"
          id="textfield-municipio"
          outlined
          v-on:keyup.native.enter="applyFilter()"
        >
          <m-floating-label for="textfield-municipio"
            >Municipio</m-floating-label
          >
        </m-text-field>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="4" :span-desktop="3">
        <m-select
          v-model="estadoSelect.valueSelected"
          id="estado-select"
          outlined
        >
          <option
            v-for="option in estadoSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="estadoSelect.valueSelected === option.value"
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="estado-select"
            :floatAbove="!!estadoSelect.valueSelected"
          >
            {{ estadoSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="2" :span-desktop="2">
        <m-select
          v-model="metrosConstruidosMinSelect.valueSelected"
          id="metrosConstruidosmin-select"
          outlined
        >
          <option
            v-for="option in metrosConstruidosMinSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="
              metrosConstruidosMinSelect.valueSelected === option.value
            "
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="metrosConstruidosmin-select"
            :floatAbove="!!metrosConstruidosMinSelect.valueSelected"
          >
            {{ metrosConstruidosMinSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="2" :span-desktop="1">
        <m-select
          v-model="metrosConstruidosMaxSelect.valueSelected"
          id="metrosConstruidosmax-select"
          outlined
        >
          <option
            v-for="option in metrosConstruidosMaxSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="
              metrosConstruidosMaxSelect.valueSelected === option.value
            "
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="metrosConstruidosmax-select"
            :floatAbove="!!metrosConstruidosMaxSelect.valueSelected"
          >
            {{ metrosConstruidosMaxSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="2" :span-desktop="2">
        <m-select
          v-model="metrosUtilesMinSelect.valueSelected"
          id="metrosutilesmin-select"
          outlined
        >
          <option
            v-for="option in metrosUtilesMinSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="metrosUtilesMinSelect.valueSelected === option.value"
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="metrosutilesmin-select"
            :floatAbove="!!metrosUtilesMinSelect.valueSelected"
          >
            {{ metrosUtilesMinSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="2" :span-desktop="1">
        <m-select
          v-model="metrosUtilesMaxSelect.valueSelected"
          id="metrosutilesmax-select"
          outlined
        >
          <option
            v-for="option in metrosUtilesMaxSelect.options"
            :key="option.text"
            :value="option.value"
            :selected="metrosUtilesMaxSelect.valueSelected === option.value"
          >
            {{ option.text }}
          </option>
          <m-floating-label
            slot="label"
            for="metrosutilesmax-select"
            :floatAbove="!!metrosUtilesMaxSelect.valueSelected"
          >
            {{ metrosUtilesMaxSelect.label }}
          </m-floating-label>
        </m-select>
      </m-layout-grid-cell>
      <m-layout-grid-cell :span-phone="2" :span-tablet="4" :span-desktop="3">
        <m-text-field
          v-model="promocion"
          id="textfield-promocion"
          outlined
          v-on:keyup.native.enter="applyFilter()"
        >
          <m-floating-label for="textfield-promocion"
            >Denominación</m-floating-label
          >
        </m-text-field>
      </m-layout-grid-cell>

      <m-layout-grid-cell :span-phone="4" :span-tablet="4" :span-desktop="3">
        <m-text-field
          v-model="referenciaInmueble"
          id="textfield-referenciaimmueble"
          outlined
          v-on:keyup.native.enter="applyFilter()"
        >
          <m-floating-label for="textfield-referenciaimmueble"
            >Referencia inmueble</m-floating-label
          >
        </m-text-field>
      </m-layout-grid-cell>
      <!-- <m-layout-grid-cell :span-phone="4" :span-tablet="4" :span-desktop="3">
        <span
          style="position:relative; top: 0.2em; line-height: 40px; margin-right: 0.4em"
        >
          <m-checkbox id="checkbox-conVideo" v-model="debeTenerVideo" />
          <label
            style="position:relative; left: -0.2em;font-size: 0.8125em; color: rgba(0, 0, 0, 0.6)"
            for="checkbox-conVideo"
            >con video promocional</label
          >
        </span>
        <span style="position:relative; top: 0.2em; line-height: 40px">
          <m-checkbox id="checkbox-conFicha" v-model="debeTenerFicha" />
          <label
            style="position:relative; left: -0.2em; font-size: 0.8125em; color: rgba(0, 0, 0, 0.6)"
            for="checkbox-conFicha"
            >con ficha</label
          >
        </span>
      </m-layout-grid-cell> -->
      <m-layout-grid-cell :span-phone="0" :span-tablet="5" :span-desktop="9" />
      <m-layout-grid-cell :span-phone="4" :span-tablet="3" :span-desktop="3">
        <m-button raised @click="applyFilter()">
          Aplicar filtro
        </m-button>
      </m-layout-grid-cell>
    </m-layout-grid-inner>
  </m-layout-grid>
</template>

<script>
export default {
  name: "app-inmuebles-list-filter-full",
  props: {
    apFilter: null
  },
  data() {
    return {
      tipoBienSelect: {
        label: "Tipo de Bien",
        valueSelected: null,
        rendered: true,
        options: [
          { text: "", value: "" },
          { text: "Suelo residencial", value: "SUELO RESIDENCIAL" },
          { text: "Suelo industrial", value: "SUELO INDUSTRIAL" },
          { text: "Suelo terciario", value: "SUELO TERCIARIO" },
          { text: "Suelo dotacional", value: "SUELO DOTACIONAL" },
          { text: "Parcela aparcamiento", value: "PARCELA APARCAMIENTO" },
          { text: "Suelo urbanizable", value: "SUELO URBANIZABLE" },
          { text: "Suelo no urbanizable", value: "SUELO NO URBANIZABLE" },
          { text: "Locales", value: "LOCALES" },
          { text: "Trasteros", value: "TRASTEROS" },
          { text: "Garajes", value: "GARAJES" },
          { text: "Naves industriales", value: "NAVES INDUSTRIALES" },
          { text: "Viviendas", value: "VIVIENDA" }
        ]
      },
      provinciaSelect: {
        label: "Provincia",
        valueSelected: null,
        valid: null,
        rendered: true,
        options: [
          { text: "", value: "" },
          { text: "Almería", value: "ALMERIA" },
          { text: "Cádiz", value: "CADIZ" },
          { text: "Córdoba", value: "CORDOBA" },
          { text: "Granada", value: "GRANADA" },
          { text: "Huelva", value: "HUELVA" },
          { text: "Jaén", value: "JAEN" },
          { text: "Málaga", value: "MALAGA" },
          { text: "Sevilla", value: "SEVILLA" }
        ]
      },
      municipio: "",
      estadoSelect: {
        label: "Estado",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "en venta", value: "S" },
          { text: "consultar", value: "N" }
        ]
      },
      metrosConstruidosMinSelect: {
        label: "m² constr.(min.)",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "40", value: "50" },
          { text: "60", value: "60" },
          { text: "80", value: "80" },
          { text: "100", value: "100" },
          { text: "200", value: "200" },
          { text: "500", value: "500" },
          { text: "1.000", value: "1000" },
          { text: "5.000", value: "5000" },
          { text: "10.000", value: "10000" },
          { text: "50.000", value: "50000" }
        ]
      },
      metrosConstruidosMaxSelect: {
        label: "max.",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "40", value: "50" },
          { text: "60", value: "60" },
          { text: "80", value: "80" },
          { text: "100", value: "100" },
          { text: "200", value: "200" },
          { text: "500", value: "500" },
          { text: "1.000", value: "1000" },
          { text: "5.000", value: "5000" },
          { text: "10.000", value: "10000" },
          { text: "50.000", value: "50000" }
        ]
      },
      metrosUtilesMinSelect: {
        label: "m² útiles (min.)",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "40", value: "50" },
          { text: "60", value: "60" },
          { text: "80", value: "80" },
          { text: "100", value: "100" },
          { text: "200", value: "200" },
          { text: "500", value: "500" },
          { text: "1.000", value: "1000" },
          { text: "5.000", value: "5000" },
          { text: "10.000", value: "10000" },
          { text: "50.000", value: "50000" }
        ]
      },
      metrosUtilesMaxSelect: {
        label: "max.",
        valueSelected: "",
        options: [
          { text: "", value: "" },
          { text: "40", value: "50" },
          { text: "60", value: "60" },
          { text: "80", value: "80" },
          { text: "100", value: "100" },
          { text: "200", value: "200" },
          { text: "500", value: "500" },
          { text: "1.000", value: "1000" },
          { text: "5.000", value: "5000" },
          { text: "10.000", value: "10000" },
          { text: "50.000", value: "50000" }
        ]
      },
      promocion: "",
      referenciaInmueble: "",
      debeTenerFicha: false,
      debeTenerVideo: false
    };
  },
  mounted() {
    this.updateFormWithFilterTerms(this.apFilter);
  },
  watch: {
    apFilter() {
      this.updateFormWithFilterTerms(this.apFilter);
    }
  },
  methods: {
    updateFormWithFilterTerms(newFilterTerms) {
      // Borramos todos los campos por si se ha dejado alguno sin completar (si no se queda el que estaba antes)
      this.tipoBienSelect.valueSelected = "";
      this.provinciaSelect.valueSelected = "";
      this.municipio = "";
      this.estadoSelect.valueSelected = "";
      this.metrosConstruidosMinSelect.valueSelected = "";
      this.metrosConstruidosMaxSelect.valueSelected = "";
      this.metrosUtilesMinSelect.valueSelected = "";
      this.metrosUtilesMaxSelect.valueSelected = "";
      this.debeTenerFicha = false;
      this.debeTenerVideo = false;

      if (newFilterTerms) {
        for (var currentTermName in newFilterTerms) {
          var currentTerm = newFilterTerms[currentTermName];

          var currentTermValue = currentTerm.value
            ? currentTerm.value
            : currentTerm;

          switch (currentTermName) {
            case "TIPO_BIEN":
              this.tipoBienSelect.valueSelected = currentTermValue;
              break;
            case "PROVINCIA":
              this.provinciaSelect.valueSelected = currentTermValue;
              break;
            case "MUNICIPIO":
              this.municipio = currentTermValue;
              break;
            case "OFERTA":
              this.estadoSelect.valueSelected = currentTermValue;
              break;
            case "PROMOCION":
              this.promocion = currentTermValue;
              break;
            case "referencia":
              this.referencia = currentTermValue;
              break;
            case "MUTILESMIN":
              this.metrosUtilesMinSelect.valueSelected = currentTermValue;
              break;
            case "MUTILESMAX":
              this.metrosUtilesMaxSelect.valueSelected = currentTermValue;
              break;
            case "MCONSTRUIDOSMIN":
              this.metrosConstruidosMinSelect.valueSelected = currentTermValue;
              break;
            case "MCONSTRUIDOSMAX":
              this.metrosConstruidosMaxSelect.valueSelected = currentTermValue;
              break;
            case "VIDEO":
              this.debeTenerVideo = currentTermValue === "SI" ? true : false;
              break;
            case "FICHA":
              this.debeTenerFicha = currentTermValue === "SI" ? true : false;
              break;
          }
        }
      }
    },
    formFields2FilterTerms() {
      var newfilterTerms = {};

      if (this.tipoBienSelect.valueSelected) {
        newfilterTerms["TIPO_BIEN"] = {
          op: "=",
          value: this.tipoBienSelect.valueSelected
        };
      }
      if (this.provinciaSelect.valueSelected) {
        newfilterTerms["PROVINCIA"] = {
          op: "=",
          value: this.provinciaSelect.valueSelected
        };
      }
      if (this.municipio && this.municipio.trim()) {
        newfilterTerms["MUNICIPIO"] = {
          op: "=",
          value: this.municipio.trim()
        };
      }
      if (this.estadoSelect.valueSelected) {
        newfilterTerms["OFERTA"] = {
          op: "=",
          value: this.estadoSelect.valueSelected
        };
      }
      if (this.promocion && this.promocion.trim()) {
        newfilterTerms["PROMOCION"] = {
          op: "=",
          value: this.promocion.trim()
        };
      }
      if (this.referenciaInmueble && this.referenciaInmueble.trim()) {
        newfilterTerms["referencia"] = {
          op: "=",
          value: this.referenciaInmueble.trim()
        };
      }
      if (this.metrosUtilesMinSelect.valueSelected) {
        newfilterTerms["MUTILESMIN"] = {
          op: "=",
          value: this.metrosUtilesMinSelect.valueSelected
        };
      }
      if (this.metrosUtilesMaxSelect.valueSelected) {
        newfilterTerms["MUTILESMAX"] = {
          op: "=",
          value: this.metrosUtilesMaxSelect.valueSelected
        };
      }
      if (this.metrosConstruidosMinSelect.valueSelected) {
        newfilterTerms["MCONSTRUIDOSMIN"] = {
          op: "=",
          value: this.metrosConstruidosMinSelect.valueSelected
        };
      }
      if (this.metrosConstruidosMaxSelect.valueSelected) {
        newfilterTerms["MCONSTRUIDOSMAX"] = {
          op: "=",
          value: this.metrosConstruidosMaxSelect.valueSelected
        };
      }
      if (this.debeTenerFicha) {
        newfilterTerms["FICHA"] = {
          op: "=",
          value: "SI"
        };
      }
      if (this.debeTenerVideo) {
        newfilterTerms["VIDEO"] = {
          op: "=",
          value: "SI"
        };
      }

      return newfilterTerms;
    },
    applyFilter() {
      this.$emit("filterApplied", this.formFields2FilterTerms());
    }
  }
};
</script>

<style lang="scss">
.app-inmuebles-list-filter-full {
  .mdc-button {
    width: 100%;
    // height: 56px;
    // font-size: 1em;
  }

  .mdc-select {
    width: 100%;

    select.mdc-select__native-control {
      padding-left: 16px; /* pq si no se ve mal en 1024 y no se ve tanto el valor si es chico */
      padding-right: 16px;
      font-size: 0.8125em;
      height: 46px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }

    .mdc-select__dropdown-icon {
      top: 13px;
    }
    .mdc-floating-label {
      top: 13px;
      font-size: 0.8125em;
    }

    .mdc-notched-outline {
      height: 46px;
    }

    // font-size: 0.9em;
  }

  .mdc-text-field {
    width: 100%;
    height: 46px;

    input.mdc-text-field__input {
      font-size: 0.8125em;
      height: 46px;
    }

    .mdc-floating-label {
      font-size: 0.8125em;
    }

    .mdc-notched-outline {
      height: 46px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }
}

.app-form__title {
  font-size: 2em;
  font-weight: bold;
  color: #263238;
}
</style>
